import { render } from "./BurgerCloseIcon.vue?vue&type=template&id=0cf14c2b"
const script = {}

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__